// extracted by mini-css-extract-plugin
export default {"container":"about_container__0rNCk","children":"about_children__Y8pn1","header":"about_header__JrTDA"};